import React from 'react';
import styled from 'styled-components'
import { SectionTitle, Section, SectionBlock } from '../../components/TwoColumnLayout';

interface Props {
	simId: string,
	puk: string,
	disabled: boolean
}

interface H4Props {
	disabled: boolean
}

const H4 = styled.h4<H4Props>`
	color: ${props => props.disabled ? 'lightgray' : '#4c4c4c'};
	font-weight: 300;
	font-size: 1.25rem;
`;

const Input = styled.input`
	margin: 0px;
`;

export const SimCardInfo: React.FC<Props> = (props: Props) => {
	return (
		<React.Fragment>
			<SectionTitle>SIM-kortin tiedot</SectionTitle>
			<Section>
				<SectionBlock>
					<label htmlFor="simId"><H4 disabled={props.disabled}>SIM-kortin numero</H4></label>
					<Input id="sim-card-number" type="text" value={props.simId} readOnly />
				</SectionBlock>
			</Section>
			<Section>
				<SectionBlock>
					<label htmlFor="simId"><H4 disabled={props.disabled}>PUK-koodi</H4></label>
					<Input id="sim-puk-code" type="text" value={props.puk} readOnly />
				</SectionBlock>
			</Section>
		</React.Fragment>
	);
};